import { render, staticRenderFns } from "./ImagePreviewComponent.vue?vue&type=template&id=73ad7c66&scoped=true&lang=pug"
import script from "./ImagePreviewComponent.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewComponent.vue?vue&type=script&lang=ts"
import style0 from "./ImagePreviewComponent.vue?vue&type=style&index=0&id=73ad7c66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ad7c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ad7c66')) {
      api.createRecord('73ad7c66', component.options)
    } else {
      api.reload('73ad7c66', component.options)
    }
    module.hot.accept("./ImagePreviewComponent.vue?vue&type=template&id=73ad7c66&scoped=true&lang=pug", function () {
      api.rerender('73ad7c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/Preview/components/ImagePreviewComponent/ImagePreviewComponent.vue"
export default component.exports